// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.catalog-survey-launcher {
  position: fixed;
  z-index: 9998;
  top: 50%;
  right: 0;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-height: 48px;
  padding: 12px 10px;
  border: 1px solid #1d355a;
  border-right: 0;
  border-radius: 14px 0 0 14px;
  background: #142642;
  color: #fff;
  box-shadow: 0 14px 30px rgba(15, 23, 42, 0.28);
  font: 800 0.85rem/1.1 "Manrope", "Segoe UI", sans-serif;
  writing-mode: vertical-rl;
  text-orientation: mixed;
  transform: translateY(-50%);
  transition: background 0.16s ease, box-shadow 0.16s ease;
}

.catalog-survey-launcher:hover,
.catalog-survey-launcher:focus-visible {
  background: #1d355a;
  box-shadow: 0 16px 34px rgba(15, 23, 42, 0.36);
  outline: 3px solid rgba(37, 99, 235, 0.28);
  outline-offset: 2px;
}

.catalog-survey-launcher__icon {
  width: 1em;
  font-size: 1.25rem;
  line-height: 1;
}

.catalog-survey-layer {
  position: fixed;
  z-index: 10000;
  inset: 0;
}

.catalog-survey-backdrop {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  padding: 0;
  border: 0;
  border-radius: 0;
  background: rgba(15, 23, 42, 0.5);
  -webkit-backdrop-filter: blur(2px);
          backdrop-filter: blur(2px);
  cursor: default;
}

.catalog-survey-drawer {
  position: absolute;
  top: 0;
  right: 0;
  display: flex;
  flex-direction: column;
  width: min(440px, 100vw);
  height: 100%;
  overflow-y: auto;
  border-left: 1px solid #dbeafe;
  background: #fff;
  color: #0f172a;
  box-shadow: -20px 0 50px rgba(15, 23, 42, 0.22);
  animation: catalog-survey-slide-in 0.22s ease-out;
  scrollbar-width: thin;
  scrollbar-color: #7e93ae #edf3f8;
  scrollbar-gutter: stable;
  overscroll-behavior: contain;
}

.catalog-survey-drawer::-webkit-scrollbar {
  width: 10px;
}

.catalog-survey-drawer::-webkit-scrollbar-track {
  border-radius: 999px;
  background: #edf3f8;
}

.catalog-survey-drawer::-webkit-scrollbar-thumb {
  min-height: 2.5rem;
  border: 2px solid #edf3f8;
  border-radius: 999px;
  background: #7e93ae;
}

.catalog-survey-drawer::-webkit-scrollbar-thumb:hover {
  background: #142642;
}

@keyframes catalog-survey-slide-in {
  from { transform: translateX(100%); }
  to { transform: translateX(0); }
}

.catalog-survey-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  padding: 26px 26px 22px;
  border-bottom: 1px solid #e2e8f0;
  background: linear-gradient(135deg, #f8fbff 0%, #eef2ff 100%);
}

.catalog-survey-header h2,
.catalog-survey-content h3,
.catalog-survey-complete h3 {
  margin: 0;
  color: #0f172a;
  font-family: "Manrope", "Segoe UI", sans-serif;
  font-weight: 800;
}

.catalog-survey-header h2 { font-size: 1.35rem; }
.catalog-survey-content h3,
.catalog-survey-complete h3 { font-size: 1.2rem; line-height: 1.4; }

.catalog-survey-eyebrow {
  display: block;
  margin-bottom: 5px;
  color: #1d4ed8;
  font-size: 0.72rem;
  font-weight: 900;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.catalog-survey-close {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  width: 38px;
  height: 38px;
  padding: 0;
  border: 0;
  border-radius: 9px;
  background: transparent;
  color: #64748b;
  font-size: 1.8rem;
  line-height: 1;
}

.catalog-survey-close:hover:not(:disabled),
.catalog-survey-close:focus-visible {
  background: #dbeafe;
  color: #142642;
  outline: none;
}

.catalog-survey-content,
.catalog-survey-complete {
  display: flex;
  flex: 1 1;
  flex-direction: column;
  padding: 28px 26px;
}

.catalog-survey-progress {
  margin-bottom: 28px;
  color: #64748b;
  font-size: 0.8rem;
  font-weight: 800;
}

.catalog-survey-progress__track {
  height: 5px;
  margin-top: 8px;
  overflow: hidden;
  border-radius: 999px;
  background: #e2e8f0;
}

.catalog-survey-progress__track span {
  display: block;
  height: 100%;
  border-radius: inherit;
  background: #2563eb;
  transition: width 0.2s ease;
}

.catalog-survey-hint {
  margin: 10px 0 24px;
  color: #64748b;
  line-height: 1.55;
}

.catalog-survey-ratings {
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  grid-gap: 7px;
  gap: 7px;
  min-width: 0;
  margin: 0;
  padding: 0;
  border: 0;
}

.catalog-survey-rating {
  display: flex;
  min-width: 0;
  min-height: 92px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 10px 4px;
  border: 1px solid #e2e8f0;
  border-radius: 13px;
  background: #f8fafc;
  cursor: pointer;
  transition: border-color 0.16s ease, background 0.16s ease, transform 0.16s ease;
}

.catalog-survey-rating:hover {
  border-color: #93c5fd;
  background: #eff6ff;
  transform: translateY(-1px);
}

.catalog-survey-rating:focus-within {
  outline: 3px solid rgba(37, 99, 235, 0.22);
  outline-offset: 2px;
}

.catalog-survey-rating.is-selected {
  border-color: #2563eb;
  background: #dbeafe;
  box-shadow: inset 0 0 0 1px #2563eb;
}

.catalog-survey-rating input {
  position: absolute;
  width: 1px;
  height: 1px;
  margin: -1px;
  overflow: hidden;
  clip: rect(0 0 0 0);
}

.catalog-survey-ratings:disabled .catalog-survey-rating {
  cursor: not-allowed;
  opacity: 0.72;
  transform: none;
}

.catalog-survey-rating__icon {
  width: 1em;
  color: #64748b;
  font-size: 2rem;
  line-height: 1;
}
.catalog-survey-rating.is-selected .catalog-survey-rating__icon {
  color: #1d4ed8;
}
.catalog-survey-rating__label {
  min-width: 0;
  color: #334155;
  font-size: 0.7rem;
  font-weight: 800;
  line-height: 1.2;
  text-align: center;
  overflow-wrap: anywhere;
}

.catalog-survey-error {
  margin: 18px 0 0;
  padding: 10px 12px;
  border: 1px solid #fecaca;
  border-radius: 9px;
  background: #fef2f2;
  color: #b91c1c;
  font-size: 0.84rem;
  font-weight: 700;
}

.catalog-survey-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: auto;
  padding-top: 32px;
}

.catalog-survey-primary,
.catalog-survey-secondary {
  min-height: 42px;
  padding: 9px 17px;
  border-radius: 9px;
  font-weight: 800;
}

.catalog-survey-primary {
  border: 1px solid #1d355a;
  background: #142642;
  color: #fff;
  box-shadow: 0 10px 20px rgba(20, 38, 66, 0.2);
}

.catalog-survey-primary:hover:not(:disabled) { background: #1d355a; }
.catalog-survey-secondary {
  border: 1px solid #cbd5e1;
  background: #fff;
  color: #142642;
}
.catalog-survey-secondary:hover:not(:disabled) { background: #eaf2ff; }
.catalog-survey-primary:focus-visible,
.catalog-survey-secondary:focus-visible {
  outline: 3px solid rgba(37, 99, 235, 0.24);
  outline-offset: 2px;
}
.catalog-survey-primary:disabled,
.catalog-survey-secondary:disabled,
.catalog-survey-close:disabled { opacity: 0.55; cursor: not-allowed; }

.catalog-survey-complete {
  align-items: center;
  justify-content: center;
  text-align: center;
}
.catalog-survey-complete__icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 64px;
  height: 64px;
  margin-bottom: 20px;
  border-radius: 50%;
  background: #dcfce7;
  color: #15803d;
  font-size: 2rem;
  font-weight: 900;
}
.catalog-survey-complete p {
  max-width: 320px;
  margin: 12px 0 26px;
  color: #64748b;
  line-height: 1.55;
}

.catalog-survey-sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  margin: -1px;
  padding: 0;
  overflow: hidden;
  border: 0;
  white-space: nowrap;
  clip: rect(0 0 0 0);
}

@media (max-width: 560px) {
  .catalog-survey-launcher {
    top: auto;
    right: 16px;
    bottom: 16px;
    gap: 7px;
    padding: 11px 14px;
    border: 1px solid #1d355a;
    border-radius: 999px;
    writing-mode: horizontal-tb;
    transform: none;
  }
  .catalog-survey-drawer { top: auto; bottom: 0; width: 100%; height: min(720px, 92dvh); border: 0; border-radius: 20px 20px 0 0; }
  .catalog-survey-header { padding: 20px; }
  .catalog-survey-content,
  .catalog-survey-complete { padding: 24px 20px; }
  .catalog-survey-ratings { gap: 5px; }
  .catalog-survey-rating { min-height: 84px; padding: 8px 2px; }
  .catalog-survey-rating__icon { font-size: 1.65rem; }
  .catalog-survey-rating__label { font-size: 0.62rem; }
}

@media (prefers-reduced-motion: reduce) {
  .catalog-survey-drawer { animation: none; }
  .catalog-survey-rating,
  .catalog-survey-progress__track span { transition: none; }
}
`, "",{"version":3,"sources":["webpack://./src/components/CatalogSurvey.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,aAAa;EACb,QAAQ;EACR,QAAQ;EACR,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,4BAA4B;EAC5B,mBAAmB;EACnB,WAAW;EACX,8CAA8C;EAC9C,uDAAuD;EACvD,yBAAyB;EACzB,uBAAuB;EACvB,2BAA2B;EAC3B,wDAAwD;AAC1D;;AAEA;;EAEE,mBAAmB;EACnB,8CAA8C;EAC9C,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,UAAU;EACV,SAAS;EACT,gBAAgB;EAChB,iCAAiC;EACjC,kCAA0B;UAA1B,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,aAAa;EACb,sBAAsB;EACtB,wBAAwB;EACxB,YAAY;EACZ,gBAAgB;EAChB,8BAA8B;EAC9B,gBAAgB;EAChB,cAAc;EACd,+CAA+C;EAC/C,iDAAiD;EACjD,qBAAqB;EACrB,gCAAgC;EAChC,wBAAwB;EACxB,4BAA4B;AAC9B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,OAAO,2BAA2B,EAAE;EACpC,KAAK,wBAAwB,EAAE;AACjC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,uBAAuB;EACvB,gCAAgC;EAChC,6DAA6D;AAC/D;;AAEA;;;EAGE,SAAS;EACT,cAAc;EACd,8CAA8C;EAC9C,gBAAgB;AAClB;;AAEA,4BAA4B,kBAAkB,EAAE;AAChD;8BAC8B,iBAAiB,EAAE,gBAAgB,EAAE;;AAEnE;EACE,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,UAAU;EACV,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,iBAAiB;EACjB,cAAc;AAChB;;AAEA;;EAEE,mBAAmB;EACnB,cAAc;EACd,aAAa;AACf;;AAEA;;EAEE,aAAa;EACb,SAAO;EACP,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,aAAQ;EAAR,QAAQ;EACR,YAAY;EACZ,SAAS;EACT,UAAU;EACV,SAAS;AACX;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,gFAAgF;AAClF;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,mCAAmC;AACrC;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,cAAc;EACd,eAAe;EACf,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;;EAEE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;EACX,6CAA6C;AAC/C;;AAEA,+CAA+C,mBAAmB,EAAE;AACpE;EACE,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;AAChB;AACA,iDAAiD,mBAAmB,EAAE;AACtE;;EAEE,0CAA0C;EAC1C,mBAAmB;AACrB;AACA;;iCAEiC,aAAa,EAAE,mBAAmB,EAAE;;AAErE;EACE,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,UAAU;EACV,gBAAgB;EAChB,SAAS;EACT,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE;IACE,SAAS;IACT,WAAW;IACX,YAAY;IACZ,QAAQ;IACR,kBAAkB;IAClB,yBAAyB;IACzB,oBAAoB;IACpB,2BAA2B;IAC3B,eAAe;EACjB;EACA,yBAAyB,SAAS,EAAE,SAAS,EAAE,WAAW,EAAE,yBAAyB,EAAE,SAAS,EAAE,4BAA4B,EAAE;EAChI,yBAAyB,aAAa,EAAE;EACxC;6BAC2B,kBAAkB,EAAE;EAC/C,0BAA0B,QAAQ,EAAE;EACpC,yBAAyB,gBAAgB,EAAE,gBAAgB,EAAE;EAC7D,+BAA+B,kBAAkB,EAAE;EACnD,gCAAgC,kBAAkB,EAAE;AACtD;;AAEA;EACE,yBAAyB,eAAe,EAAE;EAC1C;yCACuC,gBAAgB,EAAE;AAC3D","sourcesContent":[".catalog-survey-launcher {\n  position: fixed;\n  z-index: 9998;\n  top: 50%;\n  right: 0;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  min-height: 48px;\n  padding: 12px 10px;\n  border: 1px solid #1d355a;\n  border-right: 0;\n  border-radius: 14px 0 0 14px;\n  background: #142642;\n  color: #fff;\n  box-shadow: 0 14px 30px rgba(15, 23, 42, 0.28);\n  font: 800 0.85rem/1.1 \"Manrope\", \"Segoe UI\", sans-serif;\n  writing-mode: vertical-rl;\n  text-orientation: mixed;\n  transform: translateY(-50%);\n  transition: background 0.16s ease, box-shadow 0.16s ease;\n}\n\n.catalog-survey-launcher:hover,\n.catalog-survey-launcher:focus-visible {\n  background: #1d355a;\n  box-shadow: 0 16px 34px rgba(15, 23, 42, 0.36);\n  outline: 3px solid rgba(37, 99, 235, 0.28);\n  outline-offset: 2px;\n}\n\n.catalog-survey-launcher__icon {\n  width: 1em;\n  font-size: 1.25rem;\n  line-height: 1;\n}\n\n.catalog-survey-layer {\n  position: fixed;\n  z-index: 10000;\n  inset: 0;\n}\n\n.catalog-survey-backdrop {\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n  padding: 0;\n  border: 0;\n  border-radius: 0;\n  background: rgba(15, 23, 42, 0.5);\n  backdrop-filter: blur(2px);\n  cursor: default;\n}\n\n.catalog-survey-drawer {\n  position: absolute;\n  top: 0;\n  right: 0;\n  display: flex;\n  flex-direction: column;\n  width: min(440px, 100vw);\n  height: 100%;\n  overflow-y: auto;\n  border-left: 1px solid #dbeafe;\n  background: #fff;\n  color: #0f172a;\n  box-shadow: -20px 0 50px rgba(15, 23, 42, 0.22);\n  animation: catalog-survey-slide-in 0.22s ease-out;\n  scrollbar-width: thin;\n  scrollbar-color: #7e93ae #edf3f8;\n  scrollbar-gutter: stable;\n  overscroll-behavior: contain;\n}\n\n.catalog-survey-drawer::-webkit-scrollbar {\n  width: 10px;\n}\n\n.catalog-survey-drawer::-webkit-scrollbar-track {\n  border-radius: 999px;\n  background: #edf3f8;\n}\n\n.catalog-survey-drawer::-webkit-scrollbar-thumb {\n  min-height: 2.5rem;\n  border: 2px solid #edf3f8;\n  border-radius: 999px;\n  background: #7e93ae;\n}\n\n.catalog-survey-drawer::-webkit-scrollbar-thumb:hover {\n  background: #142642;\n}\n\n@keyframes catalog-survey-slide-in {\n  from { transform: translateX(100%); }\n  to { transform: translateX(0); }\n}\n\n.catalog-survey-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 16px;\n  padding: 26px 26px 22px;\n  border-bottom: 1px solid #e2e8f0;\n  background: linear-gradient(135deg, #f8fbff 0%, #eef2ff 100%);\n}\n\n.catalog-survey-header h2,\n.catalog-survey-content h3,\n.catalog-survey-complete h3 {\n  margin: 0;\n  color: #0f172a;\n  font-family: \"Manrope\", \"Segoe UI\", sans-serif;\n  font-weight: 800;\n}\n\n.catalog-survey-header h2 { font-size: 1.35rem; }\n.catalog-survey-content h3,\n.catalog-survey-complete h3 { font-size: 1.2rem; line-height: 1.4; }\n\n.catalog-survey-eyebrow {\n  display: block;\n  margin-bottom: 5px;\n  color: #1d4ed8;\n  font-size: 0.72rem;\n  font-weight: 900;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n}\n\n.catalog-survey-close {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex: 0 0 auto;\n  width: 38px;\n  height: 38px;\n  padding: 0;\n  border: 0;\n  border-radius: 9px;\n  background: transparent;\n  color: #64748b;\n  font-size: 1.8rem;\n  line-height: 1;\n}\n\n.catalog-survey-close:hover:not(:disabled),\n.catalog-survey-close:focus-visible {\n  background: #dbeafe;\n  color: #142642;\n  outline: none;\n}\n\n.catalog-survey-content,\n.catalog-survey-complete {\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  padding: 28px 26px;\n}\n\n.catalog-survey-progress {\n  margin-bottom: 28px;\n  color: #64748b;\n  font-size: 0.8rem;\n  font-weight: 800;\n}\n\n.catalog-survey-progress__track {\n  height: 5px;\n  margin-top: 8px;\n  overflow: hidden;\n  border-radius: 999px;\n  background: #e2e8f0;\n}\n\n.catalog-survey-progress__track span {\n  display: block;\n  height: 100%;\n  border-radius: inherit;\n  background: #2563eb;\n  transition: width 0.2s ease;\n}\n\n.catalog-survey-hint {\n  margin: 10px 0 24px;\n  color: #64748b;\n  line-height: 1.55;\n}\n\n.catalog-survey-ratings {\n  display: grid;\n  grid-template-columns: repeat(5, minmax(0, 1fr));\n  gap: 7px;\n  min-width: 0;\n  margin: 0;\n  padding: 0;\n  border: 0;\n}\n\n.catalog-survey-rating {\n  display: flex;\n  min-width: 0;\n  min-height: 92px;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  padding: 10px 4px;\n  border: 1px solid #e2e8f0;\n  border-radius: 13px;\n  background: #f8fafc;\n  cursor: pointer;\n  transition: border-color 0.16s ease, background 0.16s ease, transform 0.16s ease;\n}\n\n.catalog-survey-rating:hover {\n  border-color: #93c5fd;\n  background: #eff6ff;\n  transform: translateY(-1px);\n}\n\n.catalog-survey-rating:focus-within {\n  outline: 3px solid rgba(37, 99, 235, 0.22);\n  outline-offset: 2px;\n}\n\n.catalog-survey-rating.is-selected {\n  border-color: #2563eb;\n  background: #dbeafe;\n  box-shadow: inset 0 0 0 1px #2563eb;\n}\n\n.catalog-survey-rating input {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0 0 0 0);\n}\n\n.catalog-survey-ratings:disabled .catalog-survey-rating {\n  cursor: not-allowed;\n  opacity: 0.72;\n  transform: none;\n}\n\n.catalog-survey-rating__icon {\n  width: 1em;\n  color: #64748b;\n  font-size: 2rem;\n  line-height: 1;\n}\n.catalog-survey-rating.is-selected .catalog-survey-rating__icon {\n  color: #1d4ed8;\n}\n.catalog-survey-rating__label {\n  min-width: 0;\n  color: #334155;\n  font-size: 0.7rem;\n  font-weight: 800;\n  line-height: 1.2;\n  text-align: center;\n  overflow-wrap: anywhere;\n}\n\n.catalog-survey-error {\n  margin: 18px 0 0;\n  padding: 10px 12px;\n  border: 1px solid #fecaca;\n  border-radius: 9px;\n  background: #fef2f2;\n  color: #b91c1c;\n  font-size: 0.84rem;\n  font-weight: 700;\n}\n\n.catalog-survey-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n  margin-top: auto;\n  padding-top: 32px;\n}\n\n.catalog-survey-primary,\n.catalog-survey-secondary {\n  min-height: 42px;\n  padding: 9px 17px;\n  border-radius: 9px;\n  font-weight: 800;\n}\n\n.catalog-survey-primary {\n  border: 1px solid #1d355a;\n  background: #142642;\n  color: #fff;\n  box-shadow: 0 10px 20px rgba(20, 38, 66, 0.2);\n}\n\n.catalog-survey-primary:hover:not(:disabled) { background: #1d355a; }\n.catalog-survey-secondary {\n  border: 1px solid #cbd5e1;\n  background: #fff;\n  color: #142642;\n}\n.catalog-survey-secondary:hover:not(:disabled) { background: #eaf2ff; }\n.catalog-survey-primary:focus-visible,\n.catalog-survey-secondary:focus-visible {\n  outline: 3px solid rgba(37, 99, 235, 0.24);\n  outline-offset: 2px;\n}\n.catalog-survey-primary:disabled,\n.catalog-survey-secondary:disabled,\n.catalog-survey-close:disabled { opacity: 0.55; cursor: not-allowed; }\n\n.catalog-survey-complete {\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n}\n.catalog-survey-complete__icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 64px;\n  height: 64px;\n  margin-bottom: 20px;\n  border-radius: 50%;\n  background: #dcfce7;\n  color: #15803d;\n  font-size: 2rem;\n  font-weight: 900;\n}\n.catalog-survey-complete p {\n  max-width: 320px;\n  margin: 12px 0 26px;\n  color: #64748b;\n  line-height: 1.55;\n}\n\n.catalog-survey-sr-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  margin: -1px;\n  padding: 0;\n  overflow: hidden;\n  border: 0;\n  white-space: nowrap;\n  clip: rect(0 0 0 0);\n}\n\n@media (max-width: 560px) {\n  .catalog-survey-launcher {\n    top: auto;\n    right: 16px;\n    bottom: 16px;\n    gap: 7px;\n    padding: 11px 14px;\n    border: 1px solid #1d355a;\n    border-radius: 999px;\n    writing-mode: horizontal-tb;\n    transform: none;\n  }\n  .catalog-survey-drawer { top: auto; bottom: 0; width: 100%; height: min(720px, 92dvh); border: 0; border-radius: 20px 20px 0 0; }\n  .catalog-survey-header { padding: 20px; }\n  .catalog-survey-content,\n  .catalog-survey-complete { padding: 24px 20px; }\n  .catalog-survey-ratings { gap: 5px; }\n  .catalog-survey-rating { min-height: 84px; padding: 8px 2px; }\n  .catalog-survey-rating__icon { font-size: 1.65rem; }\n  .catalog-survey-rating__label { font-size: 0.62rem; }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .catalog-survey-drawer { animation: none; }\n  .catalog-survey-rating,\n  .catalog-survey-progress__track span { transition: none; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
